// MWC Watch Detail - Field editing module
// Handles edit, reset, save and report actions for watch detail fields.
// Loaded before mwc-watch-detail.js.

(function () {
  window.MWCWatchDetailFields = {
    cancelActiveFieldEdit: cancelActiveFieldEdit,
    startFieldEdit: startFieldEdit,
    resetField: resetField,
    saveField: saveField,
    reportField: reportField
  };

  function cancelActiveFieldEdit() {
    const activeSaveBtn = document.querySelector(
      ".mwc-row-edit-button[data-mwc-save-field]"
    );

    if (!activeSaveBtn) return false;

    const field = activeSaveBtn.getAttribute("data-mwc-save-field");
    const row = activeSaveBtn.closest("tr");

    if (!field || !row) return false;

    const valueDisplay = row.querySelector(
      '[data-mwc-field-value="' + field + '"]'
    );

    const valueInput = row.querySelector(
      '[data-mwc-field-input="' + field + '"]'
    );

    const resetBtn = row.querySelector(
      '[data-mwc-reset-field="' + field + '"]'
    );

    if (!valueDisplay || !valueInput) return false;

    valueInput.value = valueDisplay.textContent.trim();
    valueDisplay.style.display = "";
    valueInput.classList.add("hidden");

    if (resetBtn) {
      resetBtn.classList.add("hidden");
    }

    activeSaveBtn.textContent = "Edit";
    activeSaveBtn.removeAttribute("data-mwc-save-field");
    activeSaveBtn.setAttribute("data-mwc-edit-field", field);

    return true;
  }

  function startFieldEdit(editFieldBtn) {
    if (!editFieldBtn) return false;

    const field = editFieldBtn.getAttribute("data-mwc-edit-field");
    const row = editFieldBtn.closest("tr");

    if (!field || !row) return false;

    const valueDisplay = row.querySelector(
        '[data-mwc-field-value="' + field + '"]'
    );

    const valueInput = row.querySelector(
        '[data-mwc-field-input="' + field + '"]'
    );

    if (!valueDisplay || !valueInput) {
        console.warn("MWC edit field elements not found", field);
        return false;
    }

    valueDisplay.style.display = "none";
    valueInput.classList.remove("hidden");
    valueInput.focus();

    const resetBtn = row.querySelector(
        '[data-mwc-reset-field="' + field + '"]'
    );

    if (resetBtn && valueDisplay.classList.contains("mwc-field-custom")) {
        resetBtn.classList.remove("hidden");
    }

    editFieldBtn.textContent = "Save";
    editFieldBtn.removeAttribute("data-mwc-edit-field");
    editFieldBtn.setAttribute("data-mwc-save-field", field);

    return true;
    }

    function resetField(resetFieldBtn) {
        if (!resetFieldBtn) return false;

        const field = resetFieldBtn.getAttribute("data-mwc-reset-field");
        const row = resetFieldBtn.closest("tr");

        const input = row
            ? row.querySelector('[data-mwc-field-input="' + field + '"]')
            : null;

        const display = row
            ? row.querySelector('[data-mwc-field-value="' + field + '"]')
            : null;

        if (input && display) {
            const masterValue = display.getAttribute("data-mwc-master-value") || "";
            input.value = masterValue;
            input.focus();
            return true;
        }

        return false;
    }

    async function saveField(saveFieldBtn) {
        if (!saveFieldBtn) return false;

        const field = saveFieldBtn.getAttribute("data-mwc-save-field");
        const watchId = saveFieldBtn.getAttribute("data-mwc-watch-id");
        const row = saveFieldBtn.closest("tr");

        if (!field || !watchId || !row) {
            return false;
        }

        const input = row.querySelector(
            '[data-mwc-field-input="' + field + '"]'
        );

        const valueDisplay = row.querySelector(
            '[data-mwc-field-value="' + field + '"]'
        );

        const value = input ? input.value.trim() : "";

        try {
            await MWC.updateWatch({
            id: watchId,
            [field]: value || null
            });

            alert("Thank you. We will review this information.");

            if (valueDisplay && input) {
            valueDisplay.textContent = value;

            const masterValue =
                valueDisplay.getAttribute("data-mwc-master-value") || "";

            if (value.trim() === masterValue.trim()) {
                valueDisplay.classList.remove("mwc-field-custom");
                valueDisplay.classList.add("text-subdued");

                const resetBtn = row.querySelector(
                '[data-mwc-reset-field="' + field + '"]'
                );

                if (resetBtn) {
                resetBtn.classList.add("hidden");
                }
            } else {
                valueDisplay.classList.remove("text-subdued");
                valueDisplay.classList.add("mwc-field-custom");
            }

            valueDisplay.style.display = "";
            input.classList.add("hidden");

            saveFieldBtn.textContent = "Edit";
            saveFieldBtn.removeAttribute("data-mwc-save-field");
            saveFieldBtn.setAttribute("data-mwc-edit-field", field);
            }

            return true;
        } catch (error) {
            console.error("Failed to save field", error);
            alert("Could not save field.");
            return false;
        }
        }


       async function reportField(reportBtn) {
        if (!reportBtn) return false;

        const field = reportBtn.getAttribute("data-mwc-report");
        const fieldLabel = reportBtn.getAttribute("data-mwc-report-label") || field;
        const watchId = reportBtn.getAttribute("data-mwc-watch-id");

        if (!field || !watchId) {
            return false;
        }

        const suggestion = window.prompt(
            "What value would you say is correct for " + fieldLabel + "?",
            ""
        );

        if (suggestion === null) {
            return false;
        }

        const trimmedSuggestion = suggestion.trim();

        if (!trimmedSuggestion) {
            alert("Please enter a value.");
            return false;
        }

        try {
            await MWC.updateWatch({
            id: watchId,
            [field]: trimmedSuggestion
            });

            window.mwcWatchDetailLoaded = false;

            if (typeof window.MWCWatchDetailReload === "function") {
            window.MWCWatchDetailReload();
            }

            return true;
        } catch (error) {
            console.error("Failed to save reported value", error);
            alert("Could not save your suggestion.");
            return false;
        }
        } 

})();